import React from "react";

function Data_Warehouse() {
  return (
    <div className="courseData">
      <div className="container">
        <div className="row">
          <div className="course_details_heading">
            <h1>Python Online Course</h1>
            <br />
          </div>
          {/* <div className="imgSection">
            <img
              src={require("../../../images/courses/angular.png")}
              alt=""
            />
          </div> */}
          <div className="heading">
            {/*  */}

            <h4 style={{ color: "blue" }}>About Course</h4>
            <ul>
              <li>
                This course will run live an online through Online Learning
                Platform.{" "}
              </li>
              <li>
                {" "}
                You will be provided a online class room / meeting link daily on
                your registered mail id /WhatsApp number{" "}
              </li>
              <li>
                You will be assigned with an instructor or mentor for solving
                your queries regarding the course on a 24 X 7 basis.{" "}
              </li>
              <li>
                {" "}
                You will be provided with module wise Class Room PPT, Course
                Material, MCQ types of question, Interview Questions with
                Answers, Solved Practical Assignment for Practice and Unsolved
                Practical Question.{" "}
              </li>
              <li>
                {" "}
                For any questions or doubts, separates sessions will be arranged
                for you in a specified duration of the course.{" "}
              </li>
              <li> One mini-project will be covered during course.</li>
              <li>
                {" "}
                The problem solving facility with mentor will be provided in
                English, Marathi, and Hindi Language.{" "}
              </li>
              <li>
                {" "}
                A digital certificate from Logipool Infotech will be given to
                you after successful completion of the course.{" "}
              </li>
              <li>
                Separate Online Internship Completion Certificate from
                TechnoGrowth Software Solution Pvt. Ltd. Pune will be provided
                to you for course duration period{" "}
              </li>
            </ul>
            {/*  */}
            <h3 style={{ color: "blue" }}>Course Content</h3>

            <h4>OVERVIEW AND ENVIRONMENT SETUP</h4>
            <ul>
              <li>History of Python </li>
              <li>Python Features and Applications </li>
              <li>Local Environment Setup </li>
              <li>Getting, Installing and Running Python </li>
              <li>Career Opportunities with Python </li>
            </ul>

            <h4>BASIC SYNTAX</h4>
            <ul>
              <li> First Python Program</li>
              <li> Modes: interpreter</li>
              <li>
                {" "}
                editor and Different Python IDEs and Installation of PyCham IDE
              </li>
              <li> Python Identifiers</li>
              <li>Keywords </li>
              <li> Indentation</li>
              <li> Multi-Line Statements</li>
              <li>Quotation </li>
              <li>Comments </li>
              <li>Waiting for the User Input</li>
              <li>Multiple Statements on a Single Line</li>
            </ul>

            <h4>VARIABLE TYPES AND BASIC OPERATORS</h4>
            <ul>
              <li>Assigning Values to Variables</li>
              <li>Multiple Assignment Standard Data Types </li>
              <li>Numbers, Strings, Lists, Tuples, Dictionary </li>
              <li>Data Type Conversion and Casting Types of Operators </li>
              <li>Arithmetic Operators </li>
              <li>Comparison Operators </li>
              <li>Assignment Operators Bitwise Operators </li>
              <li>Logical Operators Membership Operators </li>
              <li>Identity Operators </li>
              <li>Operators Precedence </li>
            </ul>

            <h4>Operators Precedence</h4>
            <ul>
              <li>Accessing Values in Strings</li>
              <li>Updating Strings </li>
              <li> Escape Characters </li>
              <li>String Special Operators String Formatting Operator </li>
              <li> Triple Quotes </li>
              <li> Unicode String</li>
              <li> Built-in String Methods</li>
            </ul>

            <h4>Built-in String Methods</h4>
            <ul>
              <li>if Statement</li>
              <li>if-else Statement </li>
              <li>The elif Statement Nesting of If statement </li>
              <li>Using if-else as switch-case While Loop </li>
              <li>The Infinite Loop </li>
              <li>Using else Statement with Loops </li>
              <li>For Loop</li>
              <li>
                Iterating by Sequence Index Using else Statement with Loops{" "}
              </li>
              <li> Nested Loops </li>
              <li>Break Statement </li>
              <li>Continue Statement</li>
              <li>Pass Statement</li>
            </ul>

            <h4>LISTS</h4>
            <ul>
              <li>Python Lists</li>
              <li>Accessing Values in Lists </li>
              <li>Updating Lists </li>
              <li>Deleting List Elements </li>
              <li>Basic List Operations</li>
              <li>Indexing </li>
              <li>Slicing</li>
              <li>Matrices</li>
              <li>Built-in List Functions and Methods </li>
            </ul>

            <h4>TUPLES</h4>
            <ul>
              <li>TUPLES Accessing Values in Tuples</li>
              <li>Updating Tuples </li>
              <li>Deleting Tuple Elements </li>
              <li>Basic Tuples Operations </li>
              <li>Indexing </li>
              <li>Slicing </li>
              <li>Matrices </li>
              <li>
                No Enclosing Delimiters: Built-in Tuple Functions Combining
                Lists and Tuples
              </li>
            </ul>

            <h4>DICTIONARY</h4>
            <ul>
              <li>Accessing Values in Dictionary </li>
              <li>Updating Dictionary </li>
              <li>Delete Dictionary Elements </li>
              <li>Properties of Dictionary Keys </li>
              <li>Built-in Dictionary Functions and Methods </li>
            </ul>

            <h4>FUNCTIONS</h4>
            <ul>
              <li>Defining a Function</li>
              <li>Calling a Function </li>
              <li>Function Arguments </li>
              <li>Keyword Arguments </li>
              <li>Default Arguments </li>
              <li>Variable Length Arguments </li>
              <li>Problem Solving </li>
              <li>Passing by Reference Versus Passing by Value </li>
              <li>he Anonymous Functions : lambda, map and filters </li>
              <li>The return Statement </li>
              <li>Returning multiple values Scope of Variables </li>
              <li> Global vs Local variables </li>
            </ul>

            <h4>MODULES</h4>
            <ul>
              <li>MODULES The import Statement</li>
              <li>The from import Statement </li>
              <li> The from import * Statement: Locating Modules </li>
              <li>Creating and importing user defined modules </li>
              <li>The dir( ) Function </li>
            </ul>

            <h4>FILES I/O</h4>
            <ul>
              <li>
                Opening and Closing Files, The open Function, The file Object
                Attributes, The close( ) Method, Reading and Writing Files The
                write( ) and writelines( ) Methods, The read( ), readline( ) and
                readlines( ) Methods, Opening file in appending mode File
                Positions, seek( ) function, File and Directory Related Methods,
                Problem solving based on reading, Problem solving based on R/W
              </li>
              <li>The open Function </li>
              <li>The file Object Attributes </li>
              <li>The close( ) Method </li>
              <li>
                Reading and Writing Files The write( ) and writelines( )
                Methods, The read( ), readline( ) and readlines( ) Methods{" "}
              </li>
              <li> Opening file in appending mode File Positions </li>
              <li>seek( ) function </li>
              <li>File and Directory Related Methods </li>
              <li>Problem solving based on reading </li>
              <li>Problem solving based on R/W </li>
            </ul>

            <h4>EXCEPTIONS</h4>
            <ul>
              <li>What is Exception?</li>
              <li>
                Handling an Exception with try-except The except Clause with No
                Exceptions
              </li>
              <li>he except Clause with Multiple Exceptions </li>
              <li>The try-finally Clause </li>
              <li>The try-except-else clause </li>
              <li>Argument of an Exception </li>
              <li>Raising an Exception The Keyboard interrupt </li>
              <li>User-Defined Exceptions </li>
            </ul>

            <h4>
            CLASSES OBJECTS  AND OOPS PROGRAMMING
            </h4>
            <ul>
              <li>CLASSES OBJECTS  AND OOPS PROGRAMMING	Overview of OOP Terminology</li>
              <li>Creating Classes, Creating Instance Objects </li>
              <li>Accessing Attributes </li>
              <li>The static member attributes </li>
              <li>Built-In Class Attributes </li>
              <li>Destroying Objects (Garbage Collection) </li>
              <li>lass Inheritance </li>
              <li>Multiple </li>
              <li>Hierarchical and Multi-level inheritance </li>
              <li>Polymorphism : Overriding Methods </li>
              <li>Overloading Operators </li>
              <li>Data Hiding </li>
            </ul>

            <h4>
            Data Hiding
            </h4>
            <ul>
              <li>PYTHON FOR DATA SCIENCE	Introduction to NumPy</li>
              <li>Pandas </li>
              <li>Matplotlib </li>
              <li> SeaBorn</li>
            </ul>
            <br />
            <a href="https://drive.google.com/file/d/1DQUUE2piPGjffx4SU0Dy1Lwdww-Oumle/view?usp=sharing">
              <button type="button" class="btn btn-outline-primary">
                Join Python Course
              </button>
            </a>
            <a className="ml-3" href="https://drive.google.com/file/d/1vJhgggVi41RbZWxmdfTln_yJKR4xUCFR/view?usp=sharing">
              <button type="button" class="btn btn-outline-primary">
                View Demo
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Data_Warehouse;
